import { HisInformationItemDefaultSelectKinds, IHisInformationItemDefaultSelectBehavior } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IHisInformationKeyPropertyEditable, instanceOfIHisInformationKeyPropertyEditable } from "./IHisInformationKeyPropertyEditable";

export interface IHisInformationItemDefaultSelectBehaviorPropertyEditable extends IHisInformationKeyPropertyEditable {
  hisInformationItemDefaultSelectBehavior(): IPropertyEditable<IHisInformationItemDefaultSelectBehavior>;
  getSelectableHisInformationItemDefaultSelectKinds(): HisInformationItemDefaultSelectKinds[];
}

export function instanceOfIHisInformationItemDefaultSelectBehaviorPropertyEditable(instance: any): instance is IHisInformationItemDefaultSelectBehaviorPropertyEditable {
  return instance
      && instance.hisInformationItemDefaultSelectBehavior
      && instance.getSelectableHisInformationItemDefaultSelectKinds
      && instanceOfIPropertyEditable<IHisInformationItemDefaultSelectBehavior>(instance.hisInformationItemDefaultSelectBehavior())
      && instanceOfIHisInformationKeyPropertyEditable(instance);
}
